import { z } from "zod";

export const vtLocationSchema = z
  .object({
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    altitude: z.number().optional(),
    accuracy: z.number().optional(),
    gpsLocked: z.boolean().optional(),
    kitGrandFroidCordonChauffant: z.boolean().optional(),
    notes: z.string().optional(),
  })
  .partial();

export type VtLocation = z.infer<typeof vtLocationSchema>;
